<script setup></script>
<template>
	<div class="quiz-welcome">
		<div class="container">
			<h1 class="quiz-welcome__title game-title --mobile"><slot name="nameGame"></slot></h1>	
			<div class="quiz-welcome__container">
				<div class="quiz-welcome__content">					
					<h1 class="quiz-welcome__title game-title"><slot name="nameGame"></slot></h1>	
					<p class="quiz-welcome__text"><slot name="descLevel"></slot></p>
					<p class="quiz-welcome__text"><slot name="descGame"></slot></p>
					<div class="quiz-welcome__start-bnt">
						<slot name="btnStartGame"></slot>
					</div>
				</div>
				<div class="quiz-welcome__img"><slot name="imgGame"></slot></div>
			</div>
		</div>
	</div>
</template>
<style lang="scss" scoped>
@use "@/assets/scss/base/vars";

.quiz-welcome {
	padding: 6.2rem 0 11rem;
	@media (max-width: vars.$x480) {
		padding: 1.5rem 0 35px;
	}

	&.--matches {
		.quiz-welcome__content {
			// padding-top: 20px;
		}
	}
	&.--words {
	}

	&__container {
		display: flex;
		justify-content: space-between;
		gap: 2rem;
		@media (max-width: vars.$mn) {
			flex-direction: column-reverse;
			align-items: center;
			gap: 5rem;
			
		}
		@media (max-width: vars.$x480) {
			gap: 2rem;
		}
	}

	&__content {
		padding-top: 14.8rem;
		display: grid;
		gap: 2.6rem;
		align-items: start;
		align-content: start;
		@media (max-width: vars.$mn) {
			padding-top: 0;
		}
	}

	&__title {
		@media (max-width: vars.$xx) {
			display: none;
		}
		&.--mobile {
			display: none;
			@media (max-width: vars.$xx) {
				display: block;
				text-align: center;
				margin-bottom: 1rem;
			}
		}
	}

	&__text {
		@media (max-width: vars.$x480) {
			font-size: 1.6rem;
			text-align: center;
		}
	}

	&__start-bnt {
		display: grid;
		gap: 4rem;

		@media (max-width: vars.$xx) {
			justify-items: center;
			    gap: 2.4rem;
		}

		:deep(.btn) {
			width: fit-content;
			@media (max-width: vars.$x480) {
				padding-left: 1.8rem;
				padding-right: 1.8rem;
			}
		}
	}

	&__img {
		@extend .base-bg-light;
		border: 2.33px solid var(--border-accent-2-3);
		border-radius: 4rem;
		width: 54.9rem;
		height: 54.9rem;
		overflow: hidden;
		@media (max-width: vars.$x480) {
			width: 100%;
			height: 23.8rem;
			border-radius: 2.4rem;
		}
	}
}


</style>
